
import React, { useState } from 'react';

interface SystemPromptDebugProps {
  systemPrompt?: string;
  fullPromptContext?: Array<{role: string, content: string}> | null;
}

const SystemPromptDebug: React.FC<SystemPromptDebugProps> = ({ 
  systemPrompt, 
  fullPromptContext 
}) => {
  const [expandedView, setExpandedView] = useState(true); // Default to expanded view
  
  if (!systemPrompt && !fullPromptContext) return null;
  
  const toggleExpandView = () => {
    setExpandedView(!expandedView);
  };
  
  return (
    <div className="mb-8 p-4 bg-orange-100 border border-orange-300 rounded-lg text-sm">
      <h3 className="font-semibold text-orange-800 mb-2">Debug Mode: System Prompt</h3>
      
      <div className="flex justify-end mb-2">
        <button 
          onClick={toggleExpandView} 
          className="text-xs px-2 py-1 bg-orange-200 hover:bg-orange-300 rounded text-orange-800"
        >
          {expandedView ? 'Collapse' : 'Expand Full View'}
        </button>
      </div>
      
      {systemPrompt && (
        <div className="mb-4">
          <h4 className="font-medium text-orange-700 mb-1">System Prompt:</h4>
          <pre className={`whitespace-pre-wrap bg-white p-2 rounded border border-orange-200 text-xs overflow-auto ${
            expandedView ? 'max-h-none' : 'max-h-[200px]'
          }`}>
            {systemPrompt}
          </pre>
        </div>
      )}
      
      {fullPromptContext && fullPromptContext.length > 0 && (
        <div>
          <h4 className="font-medium text-orange-700 mb-1">Full Message Context:</h4>
          <pre className={`whitespace-pre-wrap bg-white p-2 rounded border border-orange-200 text-xs overflow-auto ${
            expandedView ? 'max-h-none' : 'max-h-[200px]'
          }`}>
            {JSON.stringify(fullPromptContext, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default SystemPromptDebug;
